import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { DTypeFormChipListField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { firstValueFrom } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { LocaleString } from '../../../translate/localeString.model';
import { CategoryNode, CategoryToReturn } from '../../../../dialogs/category-tree-dialog/category-tree-dialog.component';
import { MasterService } from '../../../master/master.service';
import { DialogsService } from '../../../../dialogs/dialogs.service';
import { LocalizeService } from '../../../pipes/localize.service';

@Component({
    selector: 'category-select-field-component',
    templateUrl: './category-select-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatChipsModule]
})
export class DtypeCategorySelectFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormChipListField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    listCategoriesOids: string[];
    displayedValue: string;
    uri: string;
    masterCaption: LocaleString;
    categoriesReturned: CategoryToReturn[] = [];
    tree: CategoryNode[];

    readonly separators = [/* COMMA */ 188, /* ENTER */ 13];

    constructor(private masterService: MasterService,
        private dialogService: DialogsService,
        private localize: LocalizeService) { }

    async ngOnInit() {
        this.displayedValue = this.field.control.value.join(',');
        this.listCategoriesOids = this.field.control.value;
        this.uri = await firstValueFrom(this.masterService.masterUri$);
        this.masterCaption = await firstValueFrom(this.masterService.masterCaption$);
        this.tree = (await firstValueFrom(this.masterService.retrieveMasterCategoryTree(this.uri))).tree;
        if (this.tree) {
            this.returnCategoriesFromTree(this.tree);
        }

        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

    async openCategoryTreeDialog() {
        this.tree = (await firstValueFrom(this.masterService.retrieveMasterCategoryTree(this.uri))).tree;
        const categoryDialog = this.dialogService.openCategoryTreeDialog(this.tree, this.uri, this.localize.transform(this.masterCaption), this.listCategoriesOids);
        categoryDialog.afterClosed().subscribe((categories) => {
            if (categories) {
                this.categoriesReturned = categories;
                const categoriesOids = [];
                for (const c of categories) {
                    categoriesOids.push(c.oid);
                }
                this.field.control.setValue(categoriesOids);
                this.listCategoriesOids = categoriesOids;
            }
        });
    }

    chipName(chip: string) {
        if (this.categoriesReturned.length > 0) {
            return this.categoriesReturned?.find(c => c.oid === chip)?.name;
        }
    }

    returnCategoriesFromTree(data: CategoryNode[]) {
        for (const oid of this.listCategoriesOids) {
            data?.forEach((node) => {
                if (node.oid === oid) {
                    this.categoriesReturned.push({ name: this.localize.transform(node.name), oid: node.oid });
                } else {
                    if (node.category?.length > 0) {
                        this.returnCategoriesFromTree(node.category);
                    }
                }
            });
        }
    }
}
